<template>
    <div :style="style" class="stuff">
        <img
            :src="url"
            :draggable="draggable"
            @mouseover="mouseover"
            @mouseout="mouseout"
            @dragstart="ondragstart"/>
        <span class="title" v-if="model">{{model.name}}</span>
        <q-btn
            icon="delete"
            flat
            round
            v-if="deletable"
            @click="remove"
        />
    </div>
</template>

<script>
    import QCard from 'quasar-framework/src/components/card/QCard'
    import QCardMain from 'quasar-framework/src/components/card/QCardMain'
    export default {
        name: 'ImageViewer',
        components: {QCardMain, QCard},
        props: ['model', 'draggable', 'src', 'deletable', 'width', 'height'],
        methods: {
            ondragstart (e) {
                e.dataTransfer.effectAllowed = 'copy'
                e.dataTransfer.setData('text', JSON.stringify(this.localModel))
            },
            remove () {
                this.$store.dispatch('remove', {
                    what: 'file',
                    id: this.localModel.id
                })
            },
            mouseover() {
                if (this.ext === 'gif') {
                    this.url = this.prefixedSrc
                }
            },
            mouseout() {
                if (this.ext === 'gif') {
                    this.url = this.prefixedSrc200px
                }
            },
            updateUrl(url) {
                if (this.timeoutId) {
                    clearTimeout(this.timeoutId);
                }

                this.url = '';
                this.timeoutId = setTimeout(() => {
                    this.url = url
                    this.timeoutId = -1;
                }, 100);
            }
        },
        computed: {
            style () {
                return `display: inline-block; padding: 3px; width: ${this.width}px; height: ${this.height}px`
            },
            ext () {
                return (this.src || this.localModel.urlPath).split('.').pop()
            },
            prefixedSrc () {
                const src = this.src || this.localModel.urlPath
                return this.$store.state.MEDIA_PREFIX + src
            },
            prefixedSrc200px () {
                const src = this.src || this.localModel.urlPath
                return this.$store.state.MEDIA_PREFIX_FOR_IMG + src
            }
        },
        mounted () {
            this.localModel = this.model
            this.updateUrl(this.prefixedSrc200px)
        },
        watch: {
            model (curr, prev) {
                if (curr !== prev) {
                    this.localModel = curr
                    this.updateUrl(this.prefixedSrc200px)
                }
            },
            fullModel (curr, prev) {
                if (curr !== prev) {
                    this.localModel = this.fullModel
                    this.updateUrl(this.prefixedSrc200px)
                }
            },
            src (curr, prev) {
                if (curr !== prev) {
                    this.updateUrl(this.prefixedSrc200px)
                }
            },
        },
        data () {
            return {
                localModel: {},
                url: '',
                timeoutId: -1
            }
        },
    }
</script>

<style scoped lang="scss">
    img {
        max-width:100%;
        max-height:100%;
        min-width:100%;
        min-height:100%;
    }

    .title {
        font-size: 15px;
        line-height: 15px;
        overflow: hidden;
        height: 1em;
    }

    .stuff {
        &:hover {
            overflow: initial;
            z-index: 122200;
        }
    }
</style>